import { ColumnEditorOptions } from "primereact/column";
import CellEditor from "../components/CellEditor";
import {
  Dropdowns,
  InputContext,
  PossibleColumnProps,
  RowType,
} from "../types";

export function createRenderCellEditor<TRow extends RowType>(
  configColumns: PossibleColumnProps<TRow>[],
  dropdownConfigs: Partial<Dropdowns>,
  closeEditor: () => void,
  inputContext?: InputContext,
) {
  return function renderCellEditor(options: ColumnEditorOptions) {
    const clickedColumn = configColumns.find(
      (column) => column.field === options.field,
    );

    if (!clickedColumn || !clickedColumn.inputType) return null;

    return (
      <CellEditor<TRow>
        column={clickedColumn}
        value={options.value as unknown}
        rowData={options.rowData as TRow}
        dropdownConfigs={dropdownConfigs}
        //setDropdownConfigs={setDropdownConfigs}
        onChange={(newValue) => options.editorCallback?.(newValue)}
        closeEditor={closeEditor}
        inputContext={inputContext}
      />
    );
  };
}
